"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealingRhythmAbilityHandler = exports.HealingRhythmActorAbilityFactory = exports.HealingRhythmAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HealingRhythmAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HealingRhythm;
        this.__typeName = "HealingRhythm";
    }
}
exports.HealingRhythmAbilityArgs = HealingRhythmAbilityArgs;
let HealingRhythmActorAbilityFactory = class HealingRhythmActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HealingRhythm", "AllAllies", 0);
    }
};
HealingRhythmActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HealingRhythm")
], HealingRhythmActorAbilityFactory);
exports.HealingRhythmActorAbilityFactory = HealingRhythmActorAbilityFactory;
let HealingRhythmAbilityHandler = class HealingRhythmAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.HealingRhythmEffectArgs(enums_1.AttributeType.Focus, 5),
            supernatural: true,
            onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "chest"), 
            // TODO: better vfx
            "BlueLightPillar"))
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
HealingRhythmAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HealingRhythm)
], HealingRhythmAbilityHandler);
exports.HealingRhythmAbilityHandler = HealingRhythmAbilityHandler;
